import { Select, SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { TipoConsumoEnum } from "core/features/consumo/typings";

const { Option } = Select;

export interface SelectTipoConsumoProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
}

function SelectTipoConsumo({ value, ...rest }: SelectTipoConsumoProps) {
  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione"
      value={value}
      {...rest}
    >
      <Option value={TipoConsumoEnum.Agua} key={TipoConsumoEnum.Agua}>
        Água
      </Option>
      <Option
        value={TipoConsumoEnum.AguaMineral}
        key={TipoConsumoEnum.AguaMineral}
      >
        Água Mineral
      </Option>
      <Option value={TipoConsumoEnum.Esgoto} key={TipoConsumoEnum.Esgoto}>
        Esgoto
      </Option>
      <Option value={TipoConsumoEnum.Energia} key={TipoConsumoEnum.Energia}>
        Energia
      </Option>
      <Option value={TipoConsumoEnum.Gas} key={TipoConsumoEnum.Gas}>
        Gás
      </Option>
    </SelectBaseAntd>
  );
}

export default SelectTipoConsumo;
